import { ApiRestService } from './_service/api-rest.service';
import { ValutazioniStoreService } from './_service/valutazioni-store.service';
import { Filtri_Valutazioni } from './models/Filtri_Valutazioni';
import { Valutazione } from './models/Valutazione';
import { Component, OnInit } from '@angular/core';
import { ServerPaginationService } from '../shared/_services/server-pagination.service';
import { ActivatedRoute, Router } from '@angular/router';
import {FileStoreService} from "../shared/_services/file-store.service";

@Component({
  selector: 'app-Valutazioni',
  templateUrl: './Valutazioni.component.html'
})
export class ValutazioniComponent implements OnInit {
  collectionSize = 0;
  page = 1;
  pageSize: number = 50;
  pagesizeserver = 4; //pagine da precaricare dal server
  newpagegenerated: number = 1;
  hasFilter: boolean = true;
  hasPagination: boolean = true;
  AddEnabled: boolean = true;
  List: Valutazione[] = [];
  Filter: Filtri_Valutazioni = new Filtri_Valutazioni();
  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private Store: ValutazioniStoreService,
    private paginationService: ServerPaginationService,
    private apirestservice: ApiRestService,
    private filestore: FileStoreService
  ) { }
  ngOnInit() {
    this.Store.$lista.subscribe(data => {
      if( data && data != null && data.data != null )
        this.List = data.data;
        else this.List = [];
    });
    this.refreshTable(1);
  }
  getPage(page: number) {
    this.page = this.paginationService.paginadellalista(page, this.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.newpagegenerated, this.pagesizeserver);
    if ((pagetosend - 1) % this.pagesizeserver === 0) {
      this.newpagegenerated = page;
      this.refreshTable(pagetosend);
    }
  }
  refreshTable(page) {
    this.Filter.page = (page - 1) / this.pagesizeserver + 1;
    this.Filter.size = this.pagesizeserver * this.pageSize;
    console.log('pagina generata',this.newpagegenerated)
    this.Store.getLista(this.Filter);
  }
  edit(value) {
    this.Store.updateSelected(value);
    this.filestore.SelectSection('valutazione');
    this.router.navigate([this.route.snapshot.queryParams['valutazioni/editor'] || 'valutazioni/editor',]);
  }
  Add(){
    this.Store.updateEditable(false);
    this.Store.updateShowAddForm(true);
    this.Store.updateSelected(new Valutazione());
    this.router.navigate([this.route.snapshot.queryParams['valutazioni/editor'] || 'valutazioni/editor',]);
  }
  delete(item: Valutazione) {
    if (confirm("Sei sicuro di voler eliminare questo elemento?")) {
      this.apirestservice.deleteValutazione(item).subscribe(
        () => this.refreshTable(this.newpagegenerated)
      );
    }
  }
}
